import { RootState } from '../../main/store/main.store.ts';

import { RenderableStory } from '../types/story-reading.types.ts';

export const selectCurrentStory = (state: RootState): RenderableStory | undefined => state.storyReading.currentStory;
